<div class="product-item">
  <app-custom-product-tags [tags]="item.categoryTags"></app-custom-product-tags>
  <a tabindex="0" [routerLink]="{ cxRoute: 'product', params: item } | cxUrl" (click)="onSelectItem(item, $event)">
    <!-- DRF, uncomment if high quality img is needed in carousels/grid
    <cx-media [container]="item.images?.PRIMARY" format="superZoom"></cx-media>
    -->
    <cx-media [container]="item.images?.PRIMARY" format="pgp" [alt]="item.name || ''"></cx-media>
    <div class="cx-manufacturer font-weight-bold d-block">
      {{item.manufacturer }}
    </div>
    @if (item.name) {
      <div class="cx-name d-block">
        <a class="cx-link" [routerLink]=" { cxRoute: 'product', params: item } | cxUrl" (click)="onSelectItem(item, $event)">
          {{ item.name }}
        </a>
      </div>
    }
    <div class="cx-code d-block">
      @if (item.averageRating) {
        <cx-star-rating [rating]="item.averageRating"></cx-star-rating>
      }
    </div>
    <div class="price">
      {{ item.price?.formattedValue }}
      @if (item?.price?.discountValue) {
        <span class="old-price">{{ item?.price?.originalPrice.formattedValue}}</span>
        <span class="discount">{{ item?.price?.discountPercentage }}</span>
      }
    </div>
  </a>
  @if (item?.stock?.notifiable) {
    <app-custom-stock-notification [product]="item"></app-custom-stock-notification>
  } @else {
    @if (item.stock?.stockLevelStatus !== 'outOfStock') {
      <cx-add-to-cart [pdp]="false" [showQuantity]="false"
      [product]="item"></cx-add-to-cart>
    }
  }


</div>
